import style from './language-switcher.scss';

const script = () => {
  const cssClass: string = 'language-switcher';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`initLanguageSwitcher`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`initLanguageSwitcher`] = true;

    // Init trigger for displaying languages
    const btnTrigger = document.createElement('span');
    btnTrigger.classList.add(`${cssClass}-trigger`);
    const select = document.createElement('select');

    const li = elt.querySelector('ul').querySelectorAll('li');
    for (const item of li) {
      const option = document.createElement('option');
      option.textContent = item.textContent;

      if (item.classList.contains('is-active')) {
        btnTrigger.textContent = item.textContent;
        option.setAttribute('selected', 'selected');
      }

      select.append(option);
    };

    select.addEventListener('change', () => {
      const index = select.selectedIndex;
      li[index].childNodes[0].click();
    });

    elt.insertBefore(btnTrigger, elt.firstChild);
    elt.insertBefore(select, btnTrigger);
  }
};

export {
  style,
  script,
};
